import seta from "../../assets/arrow.png" 
import moon from "../../assets/moon.png"
import imageBackground from "../../assets/js.jpg"


const light ={
  backgroundColor: "rgb(200, 200, 200)",
  textColor: "black",
  siteColor: "rgb(148, 30, 30)",
  hover: "rgb(97, 19, 19)",
  backgroundColorNavFooter:"rgb(154, 153, 158)",
  backgroundImage: imageBackground,
  textMenuColor: "black",
  linksColor: "black",
  subscribeCoursesColor:"black",
  arrowFooter: seta,
  iconTheme: moon

}

export default light

